import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderWrapper = styled.header`
  height: 100px;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
  z-index: 50;
  position: relative;
  transition: 0.2s;
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    background: ${(props) => (props.whiteText ? "transparent" : (props) => props.theme.body)};
  }
`;

export const HeaderMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
`;

export const Logo = styled(Link)`
  max-width: 150px;
`;

export const CreateButton = styled.div`
  background: #0088cc;
  border-radius: 25px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 126.2%;
  color: #ffffff;
  border: none;
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #0088cc;
  transition: 0.2s;
  &:hover {
    background: transparent;
    color: #0088cc;
    border: 1px solid #0088cc;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Switchers = styled.div`
  display: flex;
  align-items: center;
`;

export const ThemeSwitch = styled.button`
  width: 45px;
  height: 45px;
  background: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  & img {
    min-width: 20px;
  }
  & svg {
    & path {
      fill: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
    }
  }
`;

export const LangSwitchWrapper = styled.div`
  position: relative;
  margin-left: 10px;
  width: 45px;
  height: 45px;
`;
export const LangSwitch = styled.div`
  width: 45px;
  height: ${(props) => (props.showLangSwitch ? "120px" : "45px")};
  color: ${(props) => (props.whiteText ? "#fff" : props.theme.textColor)};
  background: ${(props) => (props.whiteText ? "#111" : props.theme.bgColor)};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: ${(props) => (props.showLangSwitch ? "25px" : "50%")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  transition: 0.2s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  & span {
    &.hidden {
      display: ${(props) => (props.showLangSwitch ? "block" : "none")};
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileButton = styled.button`
  width: 45px;
  height: 45px;
  color: ${(props) => props.theme.textColor};
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  display: none;
  & span {
    height: 2px;
    background: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
    width: 12px;
    margin: 1px 0;
    border-radius: 10px;
    display: block;
    transform: ${(props) => (props.openMenu ? "rotate(135deg)" : "rotate(0)")};
    width: ${(props) => (props.openMenu ? "24px" : "12px")};
    transition: 0.2s;
    position: ${(props) => (props.openMenu ? "absolute" : "relative")};
  }
  & span:nth-child(2) {
    transform: ${(props) => (props.openMenu ? "rotate(135deg)" : "rotate(0)")};
    width: ${(props) => (props.openMenu ? "24px" : "8px")};
    transition: 0.2s;
    position: ${(props) => (props.openMenu ? "absolute" : "relative")};
  }

  & span:nth-child(3) {
    transition: 0.2s;
    transform: ${(props) => (props.openMenu ? "rotate(45deg)" : "rotate(0)")};
    transition: 0.2s;
    width: ${(props) => (props.openMenu ? "24px" : "12px")};
    position: ${(props) => (props.openMenu ? "absolute" : "relative")};
  }
  & span:nth-child(4) {
    transform: ${(props) => (props.openMenu ? "rotate(45deg)" : "rotate(0)")};
    transition: 0.2s;
    width: ${(props) => (props.openMenu ? "24px" : "8px")};
    position: ${(props) => (props.openMenu ? "absolute" : "relative")};
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;
